import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (id) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'MAINTAIN_RECORD_DETAIL_PUT',
    method: 'PUT',
  });

  const update = () => {
    if (id) {
      exec({ url: `/api/maintain/record/detail`, data: id });
    }
  };

  useEffect(() => {
    update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return [isRequestSuccessed, update];
});
